module.exports = __webpack_public_path__ + "53ef742c7b80733665ba9b73dc58db94.pdf";